import { render, staticRenderFns } from "./Preregistered.vue?vue&type=template&id=6d18885c&scoped=true&"
import script from "./Preregistered.vue?vue&type=script&lang=js&"
export * from "./Preregistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18885c",
  null
  
)

export default component.exports